import { HStack } from '@chakra-ui/react';
import React from 'react';
import * as ThemeManager from './ThemeManager';
import { useScreenSize } from './ScreenSize';
import { ScreenSectionSymbols } from './PosScreen.Sections';

export function Footer({ children }: React.PropsWithChildren): React.ReactNode {
	const size = useScreenSize();

	const contentRef = React.useRef<HTMLDivElement>(null);
	const [hasContent, setHasContent] = React.useState(true);

	React.useEffect(() => {
		const childCount = contentRef.current?.childNodes?.length || 0;
		setHasContent(childCount > 0);
	}, [children]);

	if (!hasContent)
		return null;

	const isPhoneFooter = ThemeManager.isPhone() || size === 'small';

	if (isPhoneFooter)
		return <HStack ref={contentRef} w={'full'} h='16' bg={{ base: 'white', _dark: '{colors.neutral.900}' }} justifyContent={'space-between'} padding={'2'} color={{ base: '{colors.neutral.700}', _dark: 'white' }} borderTopWidth={'1px'} borderColor={{ base: '{colors.neutral.100}', _dark: '{colors.neutral.900}' }} overflow={'hidden'} lineHeight={'120%'}>
			{children}
		</HStack>;

	return <HStack ref={contentRef} w={'full'} h='22' bg={{ base: 'white', _dark: '{colors.neutral.900}' }} justifyContent={'space-between'} padding={'2'} color={{ base: '{colors.neutral.700}', _dark: 'white' }} borderTopWidth={'1px'} borderColor={{ base: '{colors.neutral.100}', _dark: '{colors.neutral.900}' }}>
		{children}
	</HStack>;
}

(Footer as any)[ScreenSectionSymbols.Footer] = true;

